import { cn } from "@/lib/utils";

/** Shared horizontal inset for module headers, summary strips, and body content. */
export const MODULE_WORKSPACE_X = "px-4 sm:px-6";

/** Shared vertical inset for scrollable module body content. */
export const MODULE_WORKSPACE_Y = "py-4 sm:py-6";

export const moduleWorkspaceShellClass =
  "flex flex-col flex-1 min-h-0 overflow-hidden bg-background";

export const moduleWorkspaceBodyClass = cn(
  "ordinal-scrollbar flex-1 min-h-0 overflow-auto",
  MODULE_WORKSPACE_X,
  MODULE_WORKSPACE_Y,
);

export const moduleWorkspaceNarrowContentClass = "mx-auto w-full max-w-4xl space-y-6";

export const moduleWorkspaceWideContentClass =
  "mx-auto w-full max-w-[1800px] space-y-6";

export type ModuleWorkspaceContentWidth = "narrow" | "wide" | "none";

export function moduleWorkspaceContentClass(width: ModuleWorkspaceContentWidth = "narrow") {
  if (width === "wide") return moduleWorkspaceWideContentClass;
  if (width === "none") return "space-y-6";
  return moduleWorkspaceNarrowContentClass;
}

export const moduleWorkspaceHeaderTitleRowClass = cn(
  "flex flex-wrap items-start justify-between gap-3",
  MODULE_WORKSPACE_X,
  "py-4",
);

export const moduleWorkspaceHeaderWizardClass = cn(MODULE_WORKSPACE_X, "pb-4 pt-2");

export const moduleWorkspaceSummaryStripClass = "border-t";
